type Option<T extends string> = { value: T; label: string };

type Props<T extends string> = {
  value: T;
  onChange: (value: T) => void;
  options: Option<T>[];
  disabled?: boolean;
};

export function SegmentedToggle<T extends string>({
  value,
  onChange,
  options,
  disabled,
}: Props<T>) {
  return (
    <div className="flex flex-wrap rounded-md border border-border overflow-hidden text-xs font-medium w-fit">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          disabled={disabled}
          className={`px-3 py-1.5 transition-colors ${
            value === opt.value
              ? "bg-primary text-primary-foreground"
              : "bg-background text-muted-foreground hover:text-foreground"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
